<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:0">Andrew Cahill-Lloyd is an Aussie lyricist, a script writer, and an author. He spent 10 years as a serving member in the RAAF, from 1981 to 1992.</p><br/>
<p style="text-indent:0">He has a keen interest in marine life and enjoys his marine fish tank.</p><br/>
<p style="text-indent:0">Andrew is a qualified veterinary nurse, and he is also a champion for animal rights and encourages people to adopt from animal shelters. Dax The Maine Coon Cat was adopted from an animal shelter. Andrew is a grandfather to nine girls and a boy.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?872ad810